import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SCREEN } from '../../../../assets/styles/constants';
// Constants

// Css
import { Family } from '../../../Css/Font';

const GamePopupWrapper = styled.div`
	background: white;
	position: fixed;
	width: 600px;
	border-radius: 6px;
	padding: 50px 65px;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 9999999999;

	${SCREEN.SMALL} {
		width: 90vw;
		padding: 20px 15px;
	}
`;

const Overlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: black;
	opacity: 0.7;
	z-index: 99999;
`;

const Title = styled.h3`
	
	color: #353944;
	font-weight: bold;
	text-align: center;
	margin-bottom: 20px;
`;

const Description = styled.p`
	${Family.ProximaNovaNormal};
	color: #353944;
	margin-bottom: 40px;
	text-align: center;
	${SCREEN.SMALL} {
		margin-bottom: 20px;
	}
`;

const ButtonsWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-around;
`;

const Button = styled.button`
	
	font-size: 14px;
	font-weight: bold;
	padding: 10px 0;
	width: 140px;
	cursor: pointer;
	border: 2px solid #908cff;
	border-radius: 2px;
	background: ${props => (props.inverse ? 'white' : '#908cff')};
	color: ${props => (props.inverse ? '#908cff' : 'white')};;
	&:first-child {
		margin-right: 20px;
	}
	${SCREEN.SMALL} {
		width: 110px;
	}
`;

const GamePopup = ({
	title, description, onConfirm, onCancel,
}) => (
	<>
		<Overlay onClick={onCancel} />
		<GamePopupWrapper>
			<Title>{title}</Title>
			<Description>{description}</Description>
			<ButtonsWrapper>
				<span>
					<Button onClick={onConfirm}>YES</Button>
					<Button inverse onClick={onCancel}>NO</Button>
				</span>
			</ButtonsWrapper>
		</GamePopupWrapper>
	</>
);

GamePopup.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	onConfirm: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
};

export default GamePopup;
